import type {
	AdditionalFeeItemInput,
	AdditionalFeeKidsPriceObjectInput,
	HotelPolicyI18nInput,
	QuestionItemInput,
} from "@/lib/gql/__generated__/graphql";

import type { AccommodationHotelPolicyI18nFormModel } from "../../../type";

type Props = {
	viewModel: AccommodationHotelPolicyI18nFormModel["ViewModel"];
};

export const viewModelToHotelPolicyI18nInputConverter = ({ viewModel }: Props) => {
	const input: {
		hotelPolicyI18nInput: HotelPolicyI18nInput;
	} = {
		hotelPolicyI18nInput: {
			id: viewModel.id,
			hotelID: viewModel.hotelID,
			lang: viewModel.lang,
			hotelInfo: viewModel.hotelInfo.value.map((item) => {
				return {
					description: item.description.value,
					title: item.title.value,
				} satisfies HotelPolicyI18nInput["hotelInfo"][0];
			}),

			additionalFees: viewModel.additionalFees.value.map((item) => {
				return {
					additionalID: item.additionalID.value,
					name: item.name.value,
					price: {
						// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
						amount: item.price.amount?.value,
						currencyType: item.price.currencyType.value,
					},
					billingTypeTarget: item.billingTypeTarget.value,
					billingTypeTerm: item.billingTypeTerm.value,
					billingTypeTermValidation: item.billingTypeTermValidation?.value,
					isExcludeCancelFeeTarget: item.isExcludeCancelFeeTarget?.value,
					isExcludedConsumptionTax: item.isExcludedConsumptionTax?.value,
					isNotDiscountTarget: item.isNotDiscountTarget?.value,
					isNotTargetOnDayTrip: item.isNotTargetOnDayTrip?.value,
					kidsPrices: item.kidsPrices?.value?.map((item) => {
						return {
							kidsMaxAge: item.kidsMaxAge.value,
							price: {
								amount: item.price.amount.value,
								currencyType: item.price.currencyType.value,
							},
						} satisfies AdditionalFeeKidsPriceObjectInput;
					}),
					termValidationApplyEndDt: item.termValidationApplyEndDt?.value,
					termValidationApplyStartDt: item.termValidationApplyStartDt?.value,
					useKidsPrice: item.useKidsPrice?.value,
				} satisfies AdditionalFeeItemInput;
			}),

			questions: viewModel.questions.value.map((item) => {
				return {
					options: item.options?.value?.map((item) => item.value),
					question: item.question.value,
					questionID: item.questionID.value,
					questionType: item.questionType.value,
					required: item.required?.value,
				} satisfies QuestionItemInput;
			}),
		},
	};

	return input;
};
